
window.__insp = window.__insp || [];

const inspectletAction = (key: string) => (value: any) => window.__insp.push([key, value]);

export default {
    identify: inspectletAction('identify'),
    tagSession: inspectletAction('tagSession'),
    pageUrl: inspectletAction('pageUrl')
};
